<ng-container *transloco="let t;">
  <div class="p-grid">
      <div class="p-col-12">
          <div class="card">

            <div class="card-header p-grid">
              <div class="p-col-8">
                <ng-content *ngIf="loading !== true" select="[title]"></ng-content>
              </div>
              <div class="p-col-4 p-text-right page-close">
                  <i *ngIf="close === true" class="pi pi-times" (click)="onClose()" (keyup.enter)="onClose()" role="button" aria-label="{{ t('common.labels.close') }}" tabindex="0"></i>
              </div>
            </div>

            <div aria-live="assertive">
              <p-messages [(value)]="messages"></p-messages>
            </div>
            <app-loader [loading]="loading"></app-loader>

            <ng-content *ngIf="loading !== true" select="[details]"></ng-content>

          </div>
      </div>
  </div>
</ng-container>
